<script setup>
const props = defineProps({
    category: Object,
    categoriesTextColor: String
})

</script>

<template>
    <v-hover v-slot="{ isHovering, props }">
        <div
            class="d-flex flex-column align-center rounded pa-4"
            :style="{ filter: isHovering ? 'brightness(80%)' : 'none' }"
            v-bind="props"
        >
            <v-img
                v-if="category.icon_url"
                :src="category.icon_url"
                height="35px"
                width="40px"
                class="mb-2"
            />
            <span class="font-weight-bold"
                  :style="'color: '+ categoriesTextColor+ '!important'">{{
                    category.title
                }}</span>
        </div>
    </v-hover>
</template>
